'use client'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  clickEvent,
  BumpableItemPreCheckoutModel,
  VasEntryPointModel,
} from '@marketplace-web/vas/vas-data'

import VasBanner from '../VasBanner'

import useStartBumpCheckout from '../../../hooks/useStartBumpCheckout'
import { BUMP_MULTIPLE_ITEM_SELECTION_URL } from '../../../constants/routes'
import { VasImages } from '../../../constants/vas-entry-point'

type Props = {
  bumpBanner?: VasEntryPointModel
}

const BumpBanner = ({ bumpBanner }: Props) => {
  const { track } = useTracking()
  const { startCheckout } = useStartBumpCheckout()

  if (!bumpBanner) return null

  const handleBumpBannerClick = () => {
    track(
      clickEvent({
        screen: 'current_user_profile',
        target: 'multiple_push_up',
      }),
    )

    if (bumpBanner.selectedItemId) {
      const selectedItem: BumpableItemPreCheckoutModel = {
        id: bumpBanner.selectedItemId,
        title: null,
        thumbnail: null,
      }

      startCheckout(selectedItem)

      return
    }

    navigateToPage(BUMP_MULTIPLE_ITEM_SELECTION_URL)
  }

  const bannerProps = {
    ...bumpBanner,
    onClick: handleBumpBannerClick,
    testId: 'bump-banner',
    icon: VasImages.VasBump,
  }

  return <VasBanner {...bannerProps} />
}

export default BumpBanner
